import React, { useState, useEffect, useCallback } from 'react';

import classes from './CustomInput.module.scss';
import InputLabel from '../InputLabel/InputLabel';

const CustomInput = React.forwardRef((props, ref) => {
	const [value, setValue] = useState(props.defaultValue || '');

	useEffect(() => {
		if (props.defaultValue) {
			setValue(props.defaultValue);
		}
	}, [props.defaultValue]);

	const handleChange = (e) => {
		setValue(e.target.value);
		if (props.onChange) {
			props.onChange(e.target.value);
		}
	};

	return (
		<div className={[classes.main, props.className].join(' ')} style={{ ...props.style }}>
			<InputLabel
				text={props.label}
				// extraText={props.extraText}
				// required={props.required}
				// error={props.error}
				// color={labelColor}
			/>
			<input
				readOnly={props.readOnly}
				type={props.type || 'text'}
				value={value}
				ref={ref}
				onChange={(e) => handleChange(e)}
				className={classes.input}
				placeholder={props.placeholder}
				style={{ borderColor: '#CED4DA' }}
			></input>
		</div>
	);
});

CustomInput.displayName = 'CustomInput';

export default CustomInput;
